import { IExpertItem } from 'pages/profile/interface';

export enum DirectChatMessageType {
  MESSAGE = 'message',
  FORM = 'form',
  MEETING = 'meeting',
  SYSTEM = 'system',
  NOTIFICATION = 'notification',
}

export enum DirectChatMessageSubType {
  INITIAL = 'initial',
  FORM_PENDING = 'pending',
  FORM_MARK_SUBMITTED = 'marks-submitted',
  FORM_REQUEST_RESUBMIT = 'request-resubmit',
  FORM_INVITE = 'invite',
  NAME_CHANGE = 'name-change',
}

export enum DirectChatStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
}

export interface IDirectChatAttachment {
  fileName: string;
  fileUrl: string;
  fileType: string;
  fileCategory: string;
  thumbnail: string;
}

export interface IDirectChatFormDto {
  _id: string;
  formTitle: string;
  formDescription?: string;
  formType?: string;
  passMark?: number;
  version?: string;
}

export interface IDirectChatFormSubmissionDto {
  _id: string;
  status: string;
  data?: string;
  updatedAt?: string;
  userModuleCompletion?: string;
  directChatUserSession?: string;
}

export interface IDirectChatMessage {
  _id: string;
  type: DirectChatMessageType;
  subType?: string | DirectChatMessageSubType;
  body: string;
  sent_by: string;
  attachments: IDirectChatAttachment[];
  createdAt: string;
  updatedAt: string;
  form?: IDirectChatFormDto;
  formSubmission?: IDirectChatFormSubmissionDto;
  formInvitationId?: string;
  meetingId?: string;
}

export interface IDirectChatUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  profileImgUrl: string;
  bio?: string;
}

export interface IDirectChatConversation {
  _id: string;
  title: string;
  users: IDirectChatUser[];
  experts: IExpertItem[];
  messages: IDirectChatMessage[];
  createdAt: string;
  updatedAt: string;
  directChatStatus: DirectChatStatus;
  chatCategory: string;
  unreadMessages?: {
    userId: string;
    unreadCount: number;
  }[];
}

export interface ITenantUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  profileImgUrl: string;
}

export interface IDirectChatState {
  filters: {
    keyword: string;
  };
  loading: boolean;
  conversationLoading: boolean;
  sendMessageLoading: boolean;
  sendMeetingMessageLoading: boolean;
  sendFormInviteLoading: boolean;
  conversations: IDirectChatConversation[];
  conversationsPage: number;
  conversationsTotal: number;
  conversationsLoadingMore: boolean;
  conversationId: string | null;
  conversation: IDirectChatConversation;
  tenantUsers: ITenantUser[];
  tenantUsersLoading: boolean;
  tenantUsersPage: number;
  tenantUsersTotal: number;
  tenantUsersKeyword: string;
  recentUsers: ITenantUser[];
  recentUsersLoading: boolean;
}

export interface ISendDirectMessageDto {
  body: string;
  attachments: IDirectChatAttachment[];
  resolve: any;
  reject: any;
}

export interface ISendDirectFormInviteDto {
  formIds: string[];
  chatIds: string[];
  message?: string;
}

export interface ISendDirectMeetingMessageDto {
  resolve: any;
  reject: any;
}
